<template>
  <div>
    <div id="login" class="login">
      <div class="container_login">
        <div class="container_mid">
          <div id="loginform">
            <h1 class="brand">
              {{ $t("Header[10]") }}
            </h1>
            <div class="login_wrapper">
              <div class="loginform">
                <div class="alert">You Have Successfully Logged In!</div>
                <form id="loginform">
                  <!-- login username -->
                  <p>
                    <label for="username">
                      <h3>{{ $t("authentication.username") }}</h3>
                    </label>
                    <input
                      v-model="input.username"
                      name="username"
                      type="text"
                      class="reduceInputHeight"
                      :class="{ 'is-invalid': submitted && !input.username }"
                      placeholder="Username"
                    />
                    <span v-show="!input.username" class="invalid-feedback">
                      {{ $t("authentication.requireusername") }}
                    </span>
                  </p>
                  <!-- login pw -->
                  <p>
                    <label for="password">
                      <h3>
                        {{ $t("authentication.password") }}
                      </h3>
                    </label>
                  </p>
                  <p>
                    <input
                      v-model="input.password"
                      name="password"
                      type="password"
                      class="reduceInputHeight"
                      :class="{ 'is-invalid': submitted && !password }"
                      placeholder="Password"
                    />
                    <span
                      v-show="submitted && !password"
                      class="invalid-feedback"
                    >
                      {{ $t("authentication.requirepassword") }}
                    </span>
                  </p>

                  <!-- login submit -->
                  <p>
                    <button type="button" @click="login()">
                      {{ $t("authentication.login") }}
                    </button>
                  </p>
                  <!-- forget pw -->
                  <div id="fgtPassContainer">
                    <a v-b-modal.modal-center id="fgtPass">{{
                      $t("authentication.forgetpassword")
                    }}</a>
                    <b-modal
                      id="modal-center"
                      centered
                      hide-footer
                      title="Please Enter Recovery Email"
                    >
                      <input
                        placeholder="Email"
                        required
                        v-model="recoveryEmail"
                      />
                      <button
                        @click="validateEmail"
                        :disabled="isButtonDisabled"
                        style="font-family: 'Manrope', sans-serif"
                      >
                        {{ $t("authentication.submit") }}
                      </button>
                      <span
                        id="notifyValidEmail"
                        :class="!valid ? 'warning' : 'sucess'"
                      ></span>
                      {{ buttonText }}
                    </b-modal>
                  </div>
                  <!-- go to register -->
                  <p>
                    <router-link to="/register" class="btn btn-link">
                      <button type="button">
                        {{ $t("authentication.register") }}
                      </button>
                    </router-link>
                  </p>
                  <br />

                  {{ $t("authentication.or") }}
                  <br />
                  <!-- login par firstname -->
                  <p>{{ $t("authentication.loginparticipant") }}</p>
                  <p>
                    <label for="par_firstname">
                      <h3>{{ $t("authentication.firstname") }}:</h3>
                    </label>
                  </p>
                  <p>
                    <input
                      type="text"
                      class="reduceInputHeight"
                      v-model="par_firstname"
                    />
                  </p>
                  <!-- login par lastname -->
                  <p>
                    <label for="par_lastname">
                      <h3>{{ $t("authentication.lastname") }}:</h3>
                    </label>
                  </p>
                  <p>
                    <input
                      type="text"
                      class="reduceInputHeight"
                      v-model="par_lastname"
                    />
                  </p>
                  <!-- login par email -->
                  <p>
                    <label for="par_email">
                      <h3>{{ $t("authentication.email") }}:</h3>
                    </label>
                  </p>
                  <p>
                    <input
                      type="text"
                      class="reduceInputHeight"
                      v-model="par_email"
                    />
                  </p>
                  <p>
                    <button @click="loginParticipant">
                      {{ $t("authentication.submit") }}
                    </button>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import dataService from "../services/dataService";
import instance from "../axios";

export default {
  name: "Login",

  mounted() {
    this.goTop();
    var logged = this.$store.getters.isLoggedIn;
    // console.log(logged);
    return logged;
  },

  data() {
    return {
      valid: false,
      input: {
        username: "",
        password: "",
      },
      submitted: false,
      recoveryEmail: "",
      par_firstname: "",
      par_lastname: "",
      par_email: "",
      isButtonDisabled: false,
      buttonText: "",
      countdown: 60,
    };
  },
  methods: {
    goTop() {
      window.scrollTo(0, 0);
    },
    disableButton() {
      this.isButtonDisabled = true;
      this.buttonText = `Please wait ${this.countdown}s`;

      // Start countdown
      let countdownInterval = setInterval(() => {
        this.countdown--;
        this.buttonText = `Please wait ${this.countdown}s`;

        if (this.countdown === 0) {
          clearInterval(countdownInterval);
          this.isButtonDisabled = false;
          this.buttonText = "";
          this.countdown = 60; // Reset countdown
        }
      }, 1000);
    },
    //60s for each request, call backend: if email addr in DB, send email to it with link going to a new page, like user approval; on page,
    validateEmail() {
      let re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var referenceEmail = document.getElementById("notifyValidEmail");
      // if email format is good, try to send email
      if (re.test(String(this.recoveryEmail).toLowerCase())) {
        this.disableButton();
        const data = {
          email: this.recoveryEmail,
        };
        this.valid = true;
        referenceEmail.innerHTML = "Email Sent";
        this.recoveryEmail = "";

        instance
          .post("api/forgetPassword", data)
          .then(function (response) {
            if (response.data.Username) {
              console.log(response.data);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.valid = false;
        referenceEmail.innerHTML = "Invalid Email";
      }
    },
    login() {
      if (this.input.username == "" || this.input.password == "") {
        this.submitted = true;
        return;
      } else {
        this.submitted = false;
      }
      const data = {
        username: this.input.username,
        password: this.input.password,
      };
      var tempThis = this;
      instance
        .post("api/verifylogin", data)
        .then(function (response) {
          if (response.data.Username) {
            tempThis.$store.commit(
              "setUserEventSignup",
              tempThis.cleanString(response.data.Registeredevents)
            );
            tempThis.$store.commit("setAuthUser", response.data.Username);
            tempThis.$store.commit("setUserLevel", response.data.Rolemanage);
            tempThis.$router.push("/");
          }
        })
        .catch(function (error) {
          console.log(error);
          alert(
            "Cannot login. Please check your username and password are correct."
          );
        });
    },
    cleanString(str) {
      if (str == "") {
        return "";
      }
      // Replace "[," with "["
      return JSON.parse(str.replace("[,", "["));
    },
    loginParticipant(event) {
      event.preventDefault();
      const data = {
        firstname: this.par_firstname,
        lastname: this.par_lastname,
        email: this.par_email,
      };
      var tempThis = this;

      instance
        .post("api/loginParticipant", data)
        .then(function (response) {
          if (response.data.Email) {
            let timestampsArray = JSON.parse(response.data.Timestamp);
            tempThis.$store.commit("setAuthUser", response.data.Email);
            tempThis.$store.commit("setEventID", timestampsArray);
            tempThis.$router.push("/");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
::v-deep .modal-content {
  font-family: "Manrope", sans-serif;
}
.container_login {
  background-color: #f4892f;
  border: 1px solid #dcdfe6;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  /* padding: 20px; */
}

h2 {
  margin: 0;
}
.reduceInputHeight {
  font-size: 14px;
  width: 100%;
  /* height: 100%; */
  padding: 1em;
  border: 1px solid #e6e6e6;
  background-color: #e6e6e6;
}
a {
  color: black;
}

.mail_crypt {
  unicode-bidi: bidi-override;
  direction: rtl;
}

/* loginform */
* {
  box-sizing: border-box;
}

body {
  background: #f9c75c;
  color: #f4892f;
  line-height: 1.6;
  padding: 1em;
}

.container {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 1em;
}

ul {
  list-style: none;
  padding: 0;
}

.brand {
  text-align: center;
  padding-left: 30px;
}

.brand span {
  color: #fff;
}

.login_wrapper > * {
  padding: 1em;
}

.loginform {
  background: white;
}

#fgtPassContainer {
  text-align: right;
}

#fgtPass:hover {
  cursor: pointer;
  text-decoration: underline;
  color: white;
}

/* FORM STYLES */
.container_mid form {
  display: grid;
  grid-gap: 10px;
}

.container_mid form label {
  display: block;
}

.container_mid form p {
  margin: 0;
}

.container_mid form .full {
  grid-column: 1 / 3;
}

.container_mid form button,
.container_mid form input,
.container_mid form textarea,
.container_mid form select,
.container_mid form option {
  width: 100%;
  padding: 1em;
  /* border: 1px solid #faa535; */
}

.container_mid form button {
  background: #f4892f;
  float: left;
  border: 0;
  border-radius: 4px;
  text-transform: uppercase;
}

.container_mid form button:hover,
.container_mid form button:focus {
  background: #b33d06;
  color: #fff;
  outline: 0;
  transition: background-color 2s ease-out;
  cursor: pointer;
}

.alert {
  text-align: center;
  padding: 10px;
  background: #79c879;
  color: #fff;
  margin-bottom: 10px;
  display: none;
}

/* LARGE SCREENS */
@media (min-width: 700px) {
  .login_wrapper {
    display: grid;
  }

  .login_wrapper > * {
    padding: 2em;
  }

  .company-info h3,
  .company-info ul,
  .brand {
    text-align: left;
  }
}

@media screen and (max-width: 601px) {
  .container_login_wrapper {
    display: block;
  }
}
.warning {
  color: red;
  font-weight: bolder;
}

.sucess {
  color: lightgreen;
  font-weight: bolder;
}

#notifyValidEmail {
  margin-left: 10px;
}
</style>
